export function getUserSignUpMessage(email: string, marketingOptIn: boolean) {
  return {
    blocks: [
      {
        type: 'context',
        elements: [
          {
            type: 'mrkdwn',
            text: `New user signup: *${email}*`,
          },
          {
            type: 'mrkdwn',
            text: `Marketing opt in: *${marketingOptIn ? 'TRUE' : 'FALSE'}*`,
          },
        ],
      },
    ],
  };
}
